module.exports = __webpack_public_path__ + "media/images/iconLeft__okGreen--dark-73687453d295a1ea87ba49ced8ef34f8.png";